const headers = {
  name: "Setting Taxes",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search taxes...",
      value: "",
      allowClear: true,
    },
    {
      type: "select",
      name: "taxType",
      placeholder: "Tax Type",
      value: null,
      options: [
        { value: "VAT", label: "VAT" },
        { value: "GST", label: "GST" },
        { value: "SALES_TAX", label: "Sales Tax" },
        { value: "SERVICE_TAX", label: "Service Tax" },
        { value: "EXCISE", label: "Excise" },
        { value: "CUSTOM", label: "Custom" },
      ],
      allowClear: true,
    },
    {
      type: "select",
      name: "calculationType",
      placeholder: "Calculation Type",
      value: null,
      options: [
        { value: "PERCENTAGE", label: "Percentage" },
        { value: "FIXED_AMOUNT", label: "Fixed Amount" },
      ],
      allowClear: true,
    },
    {
      type: "select",
      name: "status",
      placeholder: "Status",
      value: null,
      options: [
        { value: "true", label: "Active" },
        { value: "false", label: "Inactive" },
      ],
      allowClear: true,
    },
    {
      type: "add",
      path: "/app/settings/tax/add",
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Settings",
        path: "/app/settings",
      },
      {
        name: "Taxes",
        path: "",
      },
      {
        name: "Tax Types",
        path: "/app/settings/tax/types",
      },
    ],
    total: [
      { value: "0", label: "Total" },
      { value: "0", label: "Active" },
      { value: "0", label: "Inactive" },
    ],
  },
};

export default headers;